import { useQuery } from '@tanstack/react-query';
import { billingService, queryKeys } from '@/services';
import type { BillingPreviewParams } from '@/services/billing/billing-service';

/**
 * Month-to-date preview for one counterparty (LR-508 / T5). Disabled until a
 * counterparty is selected. Returns the array of forming statements (one per
 * currency / agreement / account) the backend computes on the fly.
 */
export const useBillingPreview = (params: BillingPreviewParams | null) => {
  return useQuery({
    // react-query hashes the key object deterministically (sorted keys, undefined
    // dropped), so the raw params ARE the cache key - no manual normalisation.
    queryKey: queryKeys.billing.previewFor(
      params
        ? (params as unknown as Record<string, string | number>)
        : undefined,
    ),
    queryFn: () => billingService.getPreview(params as BillingPreviewParams),
    enabled: params !== null && Number.isFinite(params.counterparty),
    // Preview is a live read of unbilled accruals - don't serve a stale cache on
    // reopen; refetch whenever the modal mounts.
    staleTime: 0,
    refetchOnWindowFocus: false,
  });
};
